export const storePostAttachments = (state, attachments) => {
  state.attachments = { ...attachments };
};
